export const competitionStateEnum = [
    {
        stateId: "PENDING_SIGNUP",
        stateName: "待报名"
    },
    {
        stateId: "SIGNING_UP",
        stateName: "报名中"
    },
    {
        stateId: "PENDING_COMPETITION",
        stateName: "待比赛"
    },
    {
        stateId: "IN_COMPETITION",
        stateName: "比赛中"
    },
    {
        stateId: "COMPLETED",
        stateName: "完成"
    },
    {
        stateId: "REGISTERED",
        stateName: "已报名"
    }
]